export const config = {
    HOME_PAGE: {
        SKILLSET_TITLE: "My Skillset",
        LATEST_VIDEOS_TITLE: "My latest videos",
    },
    ABOUT_ME_PAGE: {
        AVATAR_ALT_TAG: "Alejandro Martinez",
        AVATAR_SRC: "/static/images/profile.png",
        ABOUT_ME_CONTENT_PATH: "/static/content/aboutMe.md",
        RESUME_CONTENT_PATH: "/static/resume.md",
        RESUME_CONTENT_PDF_PATH: "/static/resume.pdf",
    },
};